export default __webpack_public_path__ + "static/bg992-0d272787b30afe5d80bcadf09d5dc9ff.png";